import { Sales } from "@/models/sales";
import { Pagination } from "@/models/pagination";
import { ISales, SalesState } from "@/types/sales";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<SalesState, ISales> = {
  single: (state, single) => {
    state.single = new Sales(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Sales(item));
    state.pagination = pagination;
  },
  clear: (state) => {
    state.single = new Sales();
    state.pagination = new Pagination();
  },
};

export default mutations;
